import React, { Component } from "react";
import { Form, Button, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { get } from "lodash";
import DisplayByPermission from "../../component/DisplayByPermission";
import { getLocalstorage, dateFormat } from "../../helper";
import { PATHS, ISSUE_STATUS } from "../../constant";
//import AddDecision from "./AddDecision.issueList";
import AddDecisionIssue from "./AddDecisionIssue.popUp";
//import MOMDesc from "../MOM/MOMDesc";
import IssueMOMDesc from "../MOM/IssueMOMDesc";
import { shouldDisplayIssueAction } from "../issueList/helper";
import { PreNode, ReadMore, RedirectUser } from "../reusableComponent";
import blueEditImg from "../../assets/ci_blue_edit.svg";
import whiteEditImg from "../../assets/ci_white_edit.svg";
import AgendaIssuePragatiReview from "../prgatiReview/AgendaIssuePragatiReview";
import AgendaIssuePragatiPipeline from "../prgatiReview/AgendaIssuePragatiPipeline";

const DRAFT = "DRAFT";
const REJECTED = "Rejected";
const UNDER_CENTRAL_PMG = "under central pmg";

class AgendaIssueDecision extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayPopUp: false,
      viewMoreStatus: false,
      issueAction: false
    };
  }

  onToggleModal = () => {
    this.setState(prevState => ({
      displayPopUp: !prevState["displayPopUp"],
      viewMoreStatus: false
    }));
  };
  handleViewMore = () => {
    this.onToggleModal();
    this.setState({
      viewMoreStatus: true
    });
  };

  render() {
    const {
      issue,
      agendaData,
      permission,
      project,
      handleUpdateStatus
    } = this.props;
    const {
      displayPopUp,
      viewMoreStatus,
      issueAction,
      actionsData
    } = this.state;

    const isPragatiReview = get(issue, "issuePragatiReview");
    const isPragatiPipeline = get(issue, "issuePragatiPipeLine");
    console.log("issueSingle", issue, get(issue, "meetingDecisionDTOS", []));
    const showMeetingData = get(issue, "meetingDecisionDTOS", []).find(
      value => {
        return agendaData.id === value.meetingId;
      }
    );
    console.log("showMeetingData", showMeetingData);
    // if (showMeetingData) {
    //   showMeetingData.fileDTOList = [
    //     {
    //       id: 15124,
    //       title: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
    //       mineType: null,
    //       name: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.PNG",
    //       s3Url:
    //         "https://pmiic-non-prod-assets.s3.ap-south-1.amazonaws.com/1717138615594-Capture1.PNG",
    //       s3FileName: "1717138615594-Capture1.PNG"
    //     },
    //     {
    //       id: 15123,
    //       title: "test",
    //       mineType: null,
    //       name: "test.PNG",
    //       s3Url: "https://pmiic-non-prod-assets.s3.ap-south-1.amazonaws.com/1717138615594-Capture1.PNG",
    //       s3FileName: "1717138615594-Capture1.PNG"
    //     },
    //     {
    //       id: 15124,
    //       title: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
    //       mineType: null,
    //       name: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.PNG",
    //       s3Url:
    //         "https://pmiic-non-prod-assets.s3.ap-south-1.amazonaws.com/1717138615594-Capture1.PNG",
    //       s3FileName: "1717138615594-Capture1.PNG"
    //     },
    //     {
    //       id: 15123,
    //       title: "test",
    //       mineType: null,
    //       name: "test.PNG",
    //       s3Url: "https://pmiic-non-prod-assets.s3.ap-south-1.amazonaws.com/1717138615594-Capture1.PNG",
    //       s3FileName: "1717138615594-Capture1.PNG"
    //     },
    //     {
    //       id: 15124,
    //       title: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
    //       mineType: null,
    //       name: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.PNG",
    //       s3Url:
    //         "https://pmiic-non-prod-assets.s3.ap-south-1.amazonaws.com/1717138615594-Capture1.PNG",
    //       s3FileName: "1717138615594-Capture1.PNG"
    //     },
    //   ]
    // }

    const meeting = get(issue, "meetingDecisionDTOS[0]");
    let displayActions = shouldDisplayIssueAction(actionsData);
    //console.log("showMeetingData", showMeetingData);
    const { groupCategory } = getLocalstorage("user");
    const userInfo = getLocalstorage("user");
    const isUserStatePMG = get(userInfo, "groupCategory") === "STATE_PMG";
    const centralProject =
      get(issue, "project.sponsoringMinistry", "NA") == "CENTRAL";
    const isUserPMG = get(userInfo, "groupCategory") === "PMG";
    let pendingWithSMAndPMG =
      !(
        get(issue, "status") == ISSUE_STATUS["Pending with PMG"] ||
        get(issue, "status") == ISSUE_STATUS["Pending with SM"]
      ) || get(showMeetingData, "decisionStatus") === "DRAFT";

    return (
      <>
        {get(issue, "meetingDecisionDTOS", []).length ? (
          (!(get(showMeetingData, "decisionStatus") === DRAFT) &&
            get(showMeetingData, "meetingId")) ||
          (/resolved/i.test(get(issue, "status")) && showMeetingData) ? (
            <>
              <IssueMOMDesc
                meeting={get(issue, "meetingDecisionDTOS[0]")}
                count={get(issue, "meetingDecisionDTOS").length}
                agendaData={agendaData}
                isPragati={isPragatiReview}
                isPragatiPipeline={isPragatiPipeline}
              />
              {/* {get(agendaData, "meetingStatus") === "POSTPONED" ? (
                <AgendaIssuePragatiReview
                  isPragati={get(issue, "issuePragatiReview")}
                  isAgendaDetail={true}
                  className="issue_pragati_flag agenda_detail"
                />
              ) : null} */}
            </>
          ) : null
        ) : null}

        {(get(agendaData, "meetingStatus") === "CONCLUDED" &&
          get(agendaData, "superAdminEditable") &&
          get(issue, "status") !== REJECTED) ||
        (get(agendaData, "meetingStatus") !== "CONCLUDED" &&
          get(agendaData, "meetingStatus") !== "CANCELLED" &&
          get(agendaData, "meetingStatus") !== "POSTPONED" &&
          get(issue, "status").toLowerCase() !== UNDER_CENTRAL_PMG &&
          get(issue, "status") !== REJECTED) ? (
          <div className="decision-flag-wrapper">
            <div className="issue-header-action">
              <div className="add-decision-wrapper">
                {get(issue, "meetingDecisionDTOS", []).length ? (
                  <React.Fragment>
                    {(!(get(showMeetingData, "decisionStatus") === DRAFT) &&
                      get(showMeetingData, "meetingId")) ||
                    (/resolved/i.test(get(issue, "status")) &&
                      showMeetingData) ? (
                      <>
                        {/* <IssueMOMDesc
                        meeting={get(issue, "meetingDecisionDTOS[0]")}
                        count={get(issue, "meetingDecisionDTOS").length}
                      /> */}
                        <div className="edit-decision">
                          <DisplayByPermission
                            display={!get(permission, "canViewOnlyProject")}
                          >
                            <Button
                              className="issue-add-decision-btn"
                              onClick={this.onToggleModal}
                            >
                              <img src={blueEditImg} className="editbtnImg" />
                              <img
                                src={whiteEditImg}
                                className="editbtnImgOnHover"
                              />
                              EDIT DECISION
                            </Button>
                          </DisplayByPermission>
                        </div>
                        <div
                          className={
                            get(issue, "issuePragatiReview")
                              ? "agenda_decision_flag_wrapper"
                              : "agenda_decision_pragati_flag_wrapper"
                          }
                        >
                          {/* <AgendaIssuePragatiReview
                            isPragati={get(issue, 'issuePragatiReview')}
                            isAgendaDetail={true}
                            className="issue_pragati_flag agenda_detail"
                            statepmguser={isUserStatePMG && centralProject}
                          /> */}
                          {isPragatiReview ? (
                            <AgendaIssuePragatiReview
                              isPragati={isPragatiReview}
                              isAgendaDetail={true}
                              className="issue_pragati_flag agenda_detail"
                              statepmguser={isUserStatePMG && centralProject}
                            />
                          ) : isPragatiPipeline ? (
                            <AgendaIssuePragatiPipeline
                              isPragatiPipeline={isPragatiPipeline}
                              isAgendaDetail={true}
                              className="issue_pipeline_flag agenda_detail"
                              statepmguser={isUserStatePMG && centralProject}
                            />
                          ) : null}
                          <div
                            className={
                              get(agendaData, "meetingStatus", "NA") ===
                              "SCHEDULED"
                                ? "agenda-decision-container decision-submitted-by scheduled"
                                : "agenda-decision-container decision-submitted-by not-scheduled"
                            }
                          >
                            <div className="show-date-status d-flex ml-auto">
                              {get(meeting, "decisionCreatedBy", "NA") ==
                              null ? (
                                <></>
                              ) : (
                                <>
                                  <div className="decision-submission-date">
                                    <span class="issue-created-by verified-user" />
                                    <span class="first-pp-name">
                                      <span class="issue-creator-name  text-left">
                                        <RedirectUser
                                          title={get(
                                            meeting,
                                            "decisionCreatedBy",
                                            "NA"
                                          )}
                                          id={
                                            isUserPMG == false
                                              ? get(
                                                  meeting,
                                                  "decisionCreatedById",
                                                  "NA"
                                                )
                                              : get(
                                                  meeting,
                                                  "decisionCreatedById",
                                                  "NA"
                                                )
                                          }
                                        />
                                      </span>
                                    </span>
                                  </div>
                                </>
                              )}
                            </div>
                            <div
                              className={
                                get(meeting, "decisionCreatedBy", "NA") == null
                                  ? null
                                  : "decision-submission-date issue-id-wrapper decision-left-border"
                              }
                            >
                              Decision Submitted on :{" "}
                              {dateFormat(
                                get(meeting, "decisionSubmittedOn", null)
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    ) : !/resolved/i.test(get(issue, "status")) &&
                      !/on hold/i.test(get(issue, "status")) ? (
                      <React.Fragment>
                        {get(issue, "displayActions") ? (
                          <>
                            <div className="agenda-decision-btn-wrapper">
                              <Button
                                className={`btn-orange no-padding add-decision-btn btn-down-arrow ${
                                  issueAction ? `activity-visible` : ""
                                }`}
                                onClick={this.onActionClick}
                                style={{
                                  display:
                                    isUserStatePMG && centralProject
                                      ? "none"
                                      : null
                                }}
                              >
                                Actions
                              </Button>
                              <Button
                                className="issues-add-decision-button-agenda"
                                onClick={this.onToggleModal}
                                style={{
                                  display:
                                    isUserStatePMG && centralProject
                                      ? null
                                      : "none"
                                }}
                              >
                                ADD DECISION
                              </Button>
                            </div>
                            {/* <AgendaIssuePragatiReview
                              isPragati={get(issue, 'issuePragatiReview')}
                              isAgendaDetail={true}
                              statepmguser={
                                isUserStatePMG && centralProject
                              }
                              className="issue_pragati_flag agenda_detail action-btn"
                            /> */}
                            {isPragatiReview ? (
                              <AgendaIssuePragatiReview
                                isPragati={isPragatiReview}
                                isAgendaDetail={true}
                                className="issue_pragati_flag agenda_detail action-btn"
                                statepmguser={isUserStatePMG && centralProject}
                              />
                            ) : isPragatiPipeline ? (
                              <AgendaIssuePragatiPipeline
                                isPragatiPipeline={isPragatiPipeline}
                                isAgendaDetail={true}
                                className="issue_pipeline_flag agenda_detail action-btn"
                                statepmguser={isUserStatePMG && centralProject}
                              />
                            ) : null}
                          </>
                        ) : (
                          <DisplayByPermission
                            display={!get(permission, "canViewOnlyProject")}
                          >
                            {pendingWithSMAndPMG ? (
                              <>
                                <div className="agenda-decision-btn-wrapper">
                                  <Button
                                    className="issues-add-decision-button-agenda"
                                    onClick={this.onToggleModal}
                                  >
                                    ADD DECISION
                                  </Button>
                                </div>
                                {/* <AgendaIssuePragatiReview
                                  isPragati={get(
                                    issue,
                                    'issuePragatiReview'
                                  )}
                                  isAgendaDetail={true}
                                  statepmguser={
                                    isUserStatePMG && centralProject
                                  }
                                  className={
                                    isUserStatePMG && centralProject
                                      ? 'issue_pragati_flag agenda_detail add-decision-flag-new'
                                      : 'issue_pragati_flag agenda_detail add-decision-flag'
                                  }
                                /> */}
                                {isPragatiReview ? (
                                  <AgendaIssuePragatiReview
                                    isPragati={isPragatiReview}
                                    isAgendaDetail={true}
                                    className={
                                      isUserStatePMG && centralProject
                                        ? "issue_pragati_flag agenda_detail add-decision-flag-new"
                                        : "issue_pragati_flag agenda_detail add-decision-flag"
                                    }
                                    statepmguser={
                                      isUserStatePMG && centralProject
                                    }
                                  />
                                ) : isPragatiPipeline ? (
                                  <AgendaIssuePragatiPipeline
                                    isPragatiPipeline={isPragatiPipeline}
                                    isAgendaDetail={true}
                                    className={
                                      isUserStatePMG && centralProject
                                        ? "issue_pipeline_flag agenda_detail add-decision-flag-new"
                                        : "issue_pipeline_flag agenda_detail add-decision-flag"
                                    }
                                    statepmguser={
                                      isUserStatePMG && centralProject
                                    }
                                  />
                                ) : null}
                              </>
                            ) : // <AgendaIssuePragatiReview
                            //   isPragati={get(issue, 'issuePragatiReview')}
                            //   isAgendaDetail={true}
                            //   statepmguser={
                            //     isUserStatePMG && centralProject
                            //   }
                            //   className="issue_pragati_flag agenda_detail pendingWithSM"
                            // />
                            isPragatiReview ? (
                              <AgendaIssuePragatiReview
                                isPragati={isPragatiReview}
                                isAgendaDetail={true}
                                className="issue_pragati_flag agenda_detail pendingWithSM"
                                statepmguser={isUserStatePMG && centralProject}
                              />
                            ) : isPragatiPipeline ? (
                              <AgendaIssuePragatiPipeline
                                isPragatiPipeline={isPragatiPipeline}
                                isAgendaDetail={true}
                                className="issue_pipeline_flag agenda_detail pendingWithSM"
                                statepmguser={isUserStatePMG && centralProject}
                              />
                            ) : null}
                          </DisplayByPermission>
                        )}
                        {(get(showMeetingData, "decisionStatus") === DRAFT && (
                          <p className="saved-in-draft">
                            Saved in Draft on{" "}
                            <span className="draft-on">
                              {dateFormat(
                                get(
                                  showMeetingData,
                                  "decisionSubmittedOn",
                                  "NA"
                                )
                              )}
                            </span>
                          </p>
                        )) ||
                          null}
                      </React.Fragment>
                    ) : // <AgendaIssuePragatiReview
                    //   isPragati={get(issue, 'issuePragatiReview')}
                    //   isAgendaDetail={true}
                    //   statepmguser={isUserStatePMG && centralProject}
                    //   className="issue_pragati_flag agenda_detail on-hold-scheduled"
                    // />
                    isPragatiReview ? (
                      <AgendaIssuePragatiReview
                        isPragati={isPragatiReview}
                        isAgendaDetail={true}
                        className="issue_pragati_flag agenda_detail on-hold-scheduled"
                        statepmguser={isUserStatePMG && centralProject}
                      />
                    ) : isPragatiPipeline ? (
                      <AgendaIssuePragatiPipeline
                        isPragatiPipeline={isPragatiPipeline}
                        isAgendaDetail={true}
                        className="issue_pipeline_flag agenda_detail on-hold-scheduled"
                        statepmguser={isUserStatePMG && centralProject}
                      />
                    ) : null}
                  </React.Fragment>
                ) : !/on hold/i.test(get(issue, "status")) ? (
                  get(issue, "displayActions") ? (
                    <>
                      {/* <div className="agenda-decision-btn-wrapper">
                        <Button
                          className={`btn-orange no-padding add-decision-btn btn-down-arrow ${
                            issueAction ? `activity-visible` : ""
                          }`}
                          onClick={this.onActionClick}
                          style={{
                            display:
                              isUserStatePMG && centralProject ? "none" : null
                          }}
                        >
                          Actions
                        </Button>
                      </div> */}
                      <div className="agenda-decision-btn-wrapper">
                        <Button
                          className="issues-add-decision-button-agenda"
                          onClick={this.onToggleModal}
                        >
                          ADD DECISION
                        </Button>
                      </div>
                      {/* <AgendaIssuePragatiReview
                        isPragati={get(issue, 'issuePragatiReview')}
                        isAgendaDetail={true}
                        statepmguser={isUserStatePMG && centralProject}
                        className="issue_pragati_flag agenda_detail action-btn"
                      /> */}
                      {isPragatiReview ? (
                        <AgendaIssuePragatiReview
                          isPragati={isPragatiReview}
                          isAgendaDetail={true}
                          className="issue_pragati_flag agenda_detail action-btn"
                          statepmguser={isUserStatePMG && centralProject}
                        />
                      ) : isPragatiPipeline ? (
                        <AgendaIssuePragatiPipeline
                          isPragatiPipeline={isPragatiPipeline}
                          isAgendaDetail={true}
                          className="issue_pipeline_flag agenda_detail action-btn"
                          statepmguser={isUserStatePMG && centralProject}
                        />
                      ) : null}
                    </>
                  ) : (
                    <>
                      <DisplayByPermission
                        display={!get(permission, "canViewOnlyProject")}
                      >
                        {pendingWithSMAndPMG ? (
                          <>
                            <div className="agenda-decision-btn-wrapper">
                              <Button
                                className="issues-add-decision-button-agenda"
                                onClick={this.onToggleModal}
                              >
                                ADD DECISION
                              </Button>
                            </div>
                            {/* <AgendaIssuePragatiReview
                              isPragati={get(issue, 'issuePragatiReview')}
                              isAgendaDetail={true}
                              statepmguser={
                                isUserStatePMG && centralProject
                              }
                              className="issue_pragati_flag agenda_detail add-decision-flag"
                            /> */}
                            {isPragatiReview ? (
                              <AgendaIssuePragatiReview
                                isPragati={isPragatiReview}
                                isAgendaDetail={true}
                                className="issue_pragati_flag agenda_detail pendingwithsmpmg"
                                statepmguser={isUserStatePMG && centralProject}
                              />
                            ) : isPragatiPipeline ? (
                              <AgendaIssuePragatiPipeline
                                isPragatiPipeline={isPragatiPipeline}
                                isAgendaDetail={true}
                                className="issue_pipeline_flag agenda_detail pendingwithsmpmg"
                                statepmguser={isUserStatePMG && centralProject}
                              />
                            ) : null}
                          </>
                        ) : // <AgendaIssuePragatiReview
                        //   isPragati={get(issue, 'issuePragatiReview')}
                        //   isAgendaDetail={true}
                        //   statepmguser={isUserStatePMG && centralProject}
                        //   className="issue_pragati_flag agenda_detail pendingwithsmpmg"
                        // />
                        isPragatiReview ? (
                          <AgendaIssuePragatiReview
                            isPragati={isPragatiReview}
                            isAgendaDetail={true}
                            className="issue_pragati_flag agenda_detail pendingwithsmpmg"
                            statepmguser={isUserStatePMG && centralProject}
                          />
                        ) : isPragatiPipeline ? (
                          <AgendaIssuePragatiPipeline
                            isPragatiPipeline={isPragatiPipeline}
                            isAgendaDetail={true}
                            className="issue_pipeline_flag agenda_detail pendingwithsmpmg"
                            statepmguser={isUserStatePMG && centralProject}
                          />
                        ) : null}
                      </DisplayByPermission>
                    </>
                  )
                ) : // <AgendaIssuePragatiReview
                //   isPragati={get(issue, 'issuePragatiReview')}
                //   isAgendaDetail={true}
                //   className="issue_pragati_flag agenda_detail on_hold"
                //   statepmguser={isUserStatePMG && centralProject}
                // />
                isPragatiReview ? (
                  <AgendaIssuePragatiReview
                    isPragati={isPragatiReview}
                    isAgendaDetail={true}
                    className="issue_pragati_flag agenda_detail on_hold"
                    statepmguser={isUserStatePMG && centralProject}
                  />
                ) : isPragatiPipeline ? (
                  <AgendaIssuePragatiPipeline
                    isPragatiPipeline={isPragatiPipeline}
                    isAgendaDetail={true}
                    className="issue_pipeline_flag agenda_detail on_hold"
                    statepmguser={isUserStatePMG && centralProject}
                  />
                ) : null}
              </div>
            </div>
            {/* <AgendaIssuePragatiReview
              isPragati={get(issue, "issuePragatiReview")}
              isAgendaDetail={true}
              className="issue_pragati_flag agenda_detail"
            /> */}
          </div>
        ) : (
          <>
            {get(issue, "meetingDecisionDTOS", []).length ? (
              (!(get(showMeetingData, "decisionStatus") === DRAFT) &&
                get(showMeetingData, "meetingId")) ||
              (/resolved/i.test(get(issue, "status")) &&
                showMeetingData) ? null : isPragatiReview ? ( // /> //   className="issue_pragati_flag agenda_detail agendaPostponed" //   statepmguser={isUserStatePMG && centralProject} //   isAgendaDetail={true} //   isPragati={get(issue, 'issuePragatiReview')} // <AgendaIssuePragatiReview
                <AgendaIssuePragatiReview
                  isPragati={isPragatiReview}
                  isAgendaDetail={true}
                  className="issue_pragati_flag agenda_detail agendaPostponed"
                  statepmguser={isUserStatePMG && centralProject}
                />
              ) : isPragatiPipeline ? (
                <AgendaIssuePragatiPipeline
                  isPragatiPipeline={isPragatiPipeline}
                  isAgendaDetail={true}
                  className="issue_pipeline_flag agenda_detail agendaPostponed"
                  statepmguser={isUserStatePMG && centralProject}
                />
              ) : null
            ) : // <AgendaIssuePragatiReview
            //   isPragati={get(issue, 'issuePragatiReview')}
            //   isAgendaDetail={true}
            //   statepmguser={isUserStatePMG && centralProject}
            //   className="issue_pragati_flag agenda_detail agendaPostponed"
            // />
            isPragatiReview ? (
              <AgendaIssuePragatiReview
                isPragati={isPragatiReview}
                isAgendaDetail={true}
                className="issue_pragati_flag agenda_detail agendaPostponed"
                statepmguser={isUserStatePMG && centralProject}
              />
            ) : isPragatiPipeline ? (
              <AgendaIssuePragatiPipeline
                isPragatiPipeline={isPragatiPipeline}
                isAgendaDetail={true}
                className="issue_pipeline_flag agenda_detail agendaPostponed"
                statepmguser={isUserStatePMG && centralProject}
              />
            ) : null}

            {/* {get(agendaData, "meetingStatus") === "POSTPONED" &&
            get(issue, "meetingDecisionDTOS", []).length ? (
              <div
                className={
                  get(agendaData, "meetingStatus", "NA") === "SCHEDULED"
                    ? "agenda-decision-container decision-submitted-by scheduled"
                    : "agenda-decision-container decision-submitted-by not-scheduled"
                }
              >
                <div className="show-date-status d-flex ml-auto">
                  {get(meeting, "decisionCreatedBy", "NA") == null ? (
                    <></>
                  ) : (
                    <>
                      <div className="decision-submission-date">
                        <span class="issue-created-by verified-user" />
                        <span class="first-pp-name">
                          <span class="issue-creator-name  text-left">
                            <RedirectUser
                              title={get(meeting, "decisionCreatedBy", "NA")}
                              id={
                                isUserPMG == false
                                  ? get(meeting, "decisionCreatedById", "NA")
                                  : get(meeting, "decisionCreatedById", "NA")
                              }
                            />
                          </span>
                        </span>
                      </div>
                    </>
                  )}
                </div>
                <div
                  className={
                    get(meeting, "decisionCreatedBy", "NA") == null
                      ? null
                      : "decision-submission-date issue-id-wrapper decision-left-border"
                  }
                >
                  Decision Submitted on :{" "}
                  {dateFormat(get(meeting, "decisionSubmittedOn", null))}
                </div>
              </div>
            ) : null} */}
          </>
        )}
        {console.log("hello", /resolved/i.test(get(issue, "status")))}
        <DisplayByPermission display={displayPopUp}>
          <AddDecisionIssue
            show={displayPopUp}
            redirectToAgenda={this.redirectToAgenda}
            handleClose={this.onToggleModal}
            issues={issue}
            project={project}
            meetingData={showMeetingData}
            agendaData={agendaData}
            viewMoreStatus={viewMoreStatus}
            handleUpdateStatus={handleUpdateStatus}
            isAgendaDetailPage={true}
            title={
              !showMeetingData ||
              get(showMeetingData, "decisionStatus") === DRAFT
                ? "Add"
                : "Edit"
            }
          />
        </DisplayByPermission>
      </>
    );
  }
}
export default AgendaIssueDecision;
